module.exports = __webpack_public_path__ + "img/upload-file-white.5534028c.svg";